export const availableCurrencies = [
    {
        name: 'SEK',
        code: 'sek',
        symbol: 'kr',
        prefix: false,
        decimals: 2,
        decimalSeparator: ',',
        thousandsSeparator: ' ',
        showDecimalsOnZero: false,
    },
    {
        name: 'NOK',
        code: 'nok',
        symbol: 'kr',
        prefix: false,
        decimals: 2,
        decimalSeparator: ',',
        thousandsSeparator: ' ',
        showDecimalsOnZero: false,
    },
    {
        name: 'EUR',
        code: 'eur',
        symbol: '€',
        prefix: false,
        decimals: 2,
        decimalSeparator: ',',
        thousandsSeparator: ' ',
        showDecimalsOnZero: false,
    },
    {
        name: 'USD',
        code: 'usd',
        symbol: '$',
        prefix: true,
        decimals: 2,
        decimalSeparator: '.',
        thousandsSeparator: ',',
        showDecimalsOnZero: false,
    },
    {
        name: 'DKK',
        code: 'dkk',
        symbol: 'kr',
        prefix: false,
        decimals: 2,
        decimalSeparator: ',',
        thousandsSeparator: '.',
        showDecimalsOnZero: false,
    },
    {
        name: 'GBP',
        code: 'gbp',
        symbol: '£',
        prefix: true,
        decimals: 2,
        decimalSeparator: '.',
        thousandsSeparator: ',',
        showDecimalsOnZero: false,
    },
    {
        name: 'CHF',
        code: 'chf',
        symbol: 'CHF',
        prefix: true,
        decimals: 2,
        decimalSeparator: '.',
        thousandsSeparator: ',',
        showDecimalsOnZero: false,
    },
    {
        name: 'AED',
        code: 'aed',
        symbol: 'AED',
        prefix: false,
        decimals: 2,
        decimalSeparator: '.',
        thousandsSeparator: ',',
        showDecimalsOnZero: false,
    },
    {
        name: 'NZD',
        code: 'nzd',
        symbol: 'NZ$',
        prefix: true,
        decimals: 2,
        decimalSeparator: '.',
        thousandsSeparator: ',',
        showDecimalsOnZero: false,
    },
    {
        name: 'EGP',
        code: 'egp',
        symbol: 'EGP',
        prefix: false,
        decimals: 2,
        decimalSeparator: ',',
        thousandsSeparator: ' ',
        showDecimalsOnZero: false,
    },
    {
        name: 'PLN',
        code: 'pln',
        symbol: 'PLN',
        prefix: false,
        decimals: 2,
        decimalSeparator: ',',
        thousandsSeparator: ' ',
        showDecimalsOnZero: false,
    },
    {
        name: 'SAR',
        code: 'sar',
        symbol: 'SAR',
        prefix: false,
        decimals: 2,
        decimalSeparator: ',',
        thousandsSeparator: ' ',
        showDecimalsOnZero: false,
    },
    {
        name: 'INR',
        code: 'inr',
        symbol: '₹',
        prefix: true,
        decimals: 2,
        decimalSeparator: '.',
        thousandsSeparator: ',',
        showDecimalsOnZero: false,
    },
    {
        name: 'CZK',
        code: 'czk',
        symbol: 'Kč',
        prefix: true,
        decimals: 2,
        decimalSeparator: ',',
        thousandsSeparator: ' ',
        showDecimalsOnZero: false,
    },
    {
        name: 'KRW',
        code: 'krw',
        symbol: '₩',
        prefix: true,
        decimals: 0,
        decimalSeparator: '.',
        thousandsSeparator: ',',
        showDecimalsOnZero: false,
    },
    {
        name: 'THB',
        code: 'thb',
        symbol: '฿',
        prefix: true,
        decimals: 2,
        decimalSeparator: '.',
        thousandsSeparator: ',',
        showDecimalsOnZero: false,
    },
    {
        name: 'CAD',
        code: 'cad',
        symbol: '$',
        prefix: true,
        decimals: 2,
        decimalSeparator: '.',
        thousandsSeparator: ',',
        showDecimalsOnZero: false,
    },
    {
        name: 'RON',
        code: 'ron',
        symbol: 'Lei',
        prefix: false,
        decimals: 2,
        decimalSeparator: ',',
        thousandsSeparator: '.',
        showDecimalsOnZero: false,
    },
    {
        name: 'HUF',
        code: 'huf',
        symbol: 'HUF',
        prefix: false,
        decimals: 0,
        decimalSeparator: ',',
        thousandsSeparator: ' ',
        showDecimalsOnZero: false,
    },
    {
        name: 'XCQ',
        code: 'xcq',
        symbol: 'XCQ',
        prefix: false,
        decimals: 2,
        decimalSeparator: ',',
        thousandsSeparator: ' ',
        showDecimalsOnZero: false,
    },
    {
        name: 'XCG',
        code: 'XCG',
        symbol: 'XCG',
        prefix: false,
        decimals: 2,
        decimalSeparator: ',',
        thousandsSeparator: ' ',
        showDecimalsOnZero: false,
    },
    {
        name: 'TL',
        code: 'tl',
        symbol: '₺',
        prefix: false,
        decimals: 2,
        decimalSeparator: ',',
        thousandsSeparator: ' ',
        showDecimalsOnZero: false,
    },
    {
        name: 'DA',
        code: 'dzd',
        symbol: 'DA',
        prefix: false,
        decimals: 2,
        decimalSeparator: ',',
        thousandsSeparator: ' ',
        showDecimalsOnZero: false,
    },
    {
        name: 'MXN',
        code: 'mxn',
        symbol: '$',
        prefix: true,
        decimals: 2,
        decimalSeparator: '.',
        thousandsSeparator: ',',
        showDecimalsOnZero: false,
    }
] as const;


export type Currency = typeof availableCurrencies[number]['code'];
